import { forwardRef, ReactNode } from "react";
import { ButtonHTMLAttributes } from "react";
import { useNavigate } from "@remix-run/react";
import { useSubscriptionTier } from "~/hooks/profile/useSubscriptionTier";
import { UpgradeButtonUI } from "./UpgradeButtonUI";

interface UpgradeButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  size?: "xs" | "sm" | "default" | "lg";
  className?: string;
  children?: ReactNode;
}

export const UpgradeButton = forwardRef<HTMLButtonElement, UpgradeButtonProps>(
  ({ size = "sm", className, children = "Upgrade", ...props }, ref) => {
    const navigate = useNavigate();
    const currentPlan = useSubscriptionTier();

    return (
      <UpgradeButtonUI
        ref={ref}
        size={size}
        className={className}
        currentPlan={currentPlan}
        onSeePlans={() => navigate('/pricing')}
        {...props}
      >
        {children}
      </UpgradeButtonUI>
    );
  }
);

UpgradeButton.displayName = "UpgradeButton"; 